import { render, staticRenderFns } from "./MailedIcon.vue?vue&type=template&id=73ed18da"
import script from "./MailedIcon.vue?vue&type=script&lang=ts"
export * from "./MailedIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports